module.exports = __webpack_public_path__ + "static/media/evsa.8149cb47.png";